import * as React from "react";
import { cn } from "@/lib/utils";
import { buildWhatsAppHref } from "@/lib/whatsapp";

function WhatsAppIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      className={className}
      role="img"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="currentColor"
        d="M19.11 17.47c-.27-.13-1.6-.79-1.85-.88-.25-.09-.43-.13-.61.13-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.13-1.14-.42-2.17-1.33-.8-.71-1.34-1.58-1.5-1.85-.16-.27-.02-.42.12-.55.12-.12.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.04-.34-.02-.48-.07-.13-.61-1.47-.84-2.02-.22-.53-.44-.46-.61-.47l-.52-.01c-.18 0-.48.07-.73.34-.25.27-.96.94-.96 2.29 0 1.35.99 2.65 1.13 2.83.14.18 1.95 2.97 4.72 4.16.66.29 1.18.46 1.58.59.66.21 1.27.18 1.74.11.53-.08 1.6-.65 1.83-1.28.23-.63.23-1.17.16-1.28-.07-.11-.25-.18-.52-.32Z"
      />
      <path
        fill="currentColor"
        d="M16 3C8.83 3 3 8.62 3 15.53c0 2.41.69 4.65 1.88 6.56L3.6 28.9l7.04-1.84A13.2 13.2 0 0 0 16 28.06c7.17 0 13-5.62 13-12.53C29 8.62 23.17 3 16 3Zm0 22.95c-1.89 0-3.72-.5-5.33-1.45l-.38-.22-4.18 1.09 1.11-4.04-.25-.4a10.98 10.98 0 0 1-1.73-5.84C5.24 9.82 10.12 5.06 16 5.06c5.88 0 10.76 4.76 10.76 10.59 0 5.83-4.88 10.3-10.76 10.3Z"
      />
    </svg>
  );
}

type WhatsAppPhoneLinkProps = {
  phoneNumber: string;
  className?: string;
  textClassName?: string;
  iconLinkClassName?: string;
  iconOnly?: boolean;
  ariaLabel?: string;
  onLinkClick?: React.MouseEventHandler<HTMLAnchorElement>;
};

export function WhatsAppPhoneLink({
  phoneNumber,
  className,
  textClassName,
  iconLinkClassName,
  iconOnly = false,
  ariaLabel,
  onLinkClick,
}: WhatsAppPhoneLinkProps) {
  const href = buildWhatsAppHref(phoneNumber);

  if (!href) {
    return <span className={className}>{phoneNumber}</span>;
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      onClick={onLinkClick}
      className={cn(
        "truncate hover:underline inline-flex items-center gap-2",
        iconOnly ? iconLinkClassName : textClassName,
      )}
      aria-label={ariaLabel ?? `Abrir WhatsApp para ${phoneNumber}`}
    >
      {iconOnly ? null : phoneNumber}
      <WhatsAppIcon className="h-4 w-4" />
    </a>
  );
}
